module.exports = fox._r("fonts/icon-mc_other2.ttf?ctdsoz", __webpack_public_path__ + "_/_/_/common/frame/fonts/30FU8LI.ttf");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/fonts/icon-mc_other2.ttf?ctdsoz
// module id = 148
// module chunks = 2